import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { classNames } from 'utils/utils'
import useInterval from 'hooks/useInterval'

import withStyle from './LoadingMeter.style'

const LoadingMeter = ({ className, interval, length, height, step }) => {
  const [strokeDashoffset, setStrokeDashoffset] = useState(length)

  useInterval(() => {
    if (strokeDashoffset <= 0) setStrokeDashoffset(length)

    if (strokeDashoffset <= length && strokeDashoffset > 0)
      setStrokeDashoffset(strokeDashoffset - step)
  }, interval)

  const d = `M0 ${height / 2}h${length}`

  return (
    <svg
      className={classNames('loading-meter', className, strokeDashoffset)}
      width={length}
      height={height}
    >
      <path className="bg" d={d} />
      <path
        className="meter"
        d={d}
        strokeDasharray={length}
        strokeDashoffset={strokeDashoffset}
      />
    </svg>
  )
}

LoadingMeter.defaultProps = {
  step: 1,
  length: 200,
  interval: 5,
  height: 20,
}

LoadingMeter.propTypes = {
  className: PropTypes.string,
  interval: PropTypes.number,
  length: PropTypes.number,
  height: PropTypes.number,
  step: PropTypes.number,
}

export default React.memo(withStyle(LoadingMeter))
